import { IconProps } from '../../types/IconProps';

export const Loading = ({ variant, className }: IconProps) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    className={`${className || ''} animate-spin`}>
    <path
      fill={variant === 'light' ? '#fff' : '#0B223E'}
      d='M14.941 20.081c.265.727-.11 1.54-.866 1.701a10 10 0 1 1 7.772-11.522c.135.761-.48 1.413-1.252 1.44-.773.027-1.408-.584-1.583-1.337a7.201 7.201 0 0 0-14.208 1.888 7.2 7.2 0 0 0 8.305 6.863c.764-.119 1.568.24 1.832.967Z'
    />
  </svg>
);
